import { render, staticRenderFns } from "./01.vue?vue&type=template&id=2387c9aa&scoped=true&"
import script from "./01.vue?vue&type=script&lang=js&"
export * from "./01.vue?vue&type=script&lang=js&"
import style0 from "./01.vue?vue&type=style&index=0&id=2387c9aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387c9aa",
  null
  
)

component.options.__file = "01.vue"
export default component.exports